import { styled } from '@mui/material/styles'
import { Link } from 'react-router-dom'

export const SearchResultWrapper = styled('div')(({ theme }) => ({
  position: 'absolute',
  width: '94%',
  backgroundColor: theme.palette.common.white,
  border: `1px solid ${theme.palette.grey[200]}`, //#B0B7C3
  borderTop: '0 solid',
  boxShadow: '0px 4px 8px -4px rgba(39, 40, 51, 0.08)',
  borderRadius: '0px 0px 4px 4px',
  padding: '10px',
  zIndex: '5',
  height: '400px',
  overflow: 'auto',

  '&.no-search-result': {
    height: '78px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: theme.palette.grey[500], //'#B0B7C3'
    textAlign: 'center',
    fontSize: '14px',
    fontWeight: '400',
    lineHeight: '18px',
    span: {
      display: 'block',
    },
  },
}))

export const ResultItemWrapper = styled('div')(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.grey[300]}`, //#E5E5E5
  padding: '10px 0px',
}))

export const PropertyWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',

  '.property-info': {
    width: '50%',
  },

  '.info-name': {
    color: theme.palette.primary.main,
    fontSize: '16px',
    fontWeight: '500',
    lineHeight: '18px',
    marginBottom: '4px',
  },

  '.info-address': {
    fontSize: '16px',
    fontWeight: '400',
    letterSpacing: '0.15px',
    lineHeight: '24px',
    color: theme.palette.text.primary,
    margin: '6px 0px',
  },
}))

export const ContactWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  marginBottom: '3px',

  span: {
    fontSize: '14px',
    fontWeight: '400',
    fontStyle: 'normal',
    borderRight: `1px solid ${theme.palette.grey[300]}`, //theme.GREY_VARIANT
    marginRight: '4px',
    paddingRight: '8px',
    color: theme.palette.common.black, //theme.BLACK_0
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: 'block',
    '&:last-child': {
      borderRight: 'none',
      paddingRight: '0px',
      paddingLeft: '8px',
    },

    '&:first-child': {
      paddingLeft: '0px',
    },
  },
}))

export const LinkWrapper = styled(Link)({
  textDecoration: 'none',
})
